import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SharedService } from "./shared.service";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { Universe } from "../interfaces/universe.interface";

@Injectable({
	providedIn: 'root'
})
export class UniverseService {

	private sharedService = inject(SharedService);
	private http = inject(HttpClient);

	// public currentUniverse?: Universe;
	private currentUniverseSubject = new BehaviorSubject<Universe | null>(null);
	public currentUniverse$ = this.currentUniverseSubject.asObservable();


	constructor() {
		// Se ejecuta automáticamente cada vez que cambia
		this.currentUniverse$.subscribe(universe => {
			if (universe) {
				this.applyUniverseClass(universe);
			}
		});
	}

	setUniverse(universe: Universe) {
		this.currentUniverseSubject.next(universe);
	}

	getCurrentUniverse(): Universe | null {
		return this.currentUniverseSubject.value;
	}

	private applyUniverseClass(universe: Universe) {
		const body = document.body;

		Array.from(body.classList)
		.filter(c => c.startsWith('universe-'))
		.forEach(c => body.classList.remove(c));

		body.classList.add(`universe-${universe.id_universe}`);
	}


	async selectUniverse(id_universe?: string) {

		const universes = await this.sharedService.getUniverses();

		// Si no hay universo, añadir el de por defecto
		if (!id_universe && universes.length) {
			let defaultUniverse = universes.find(u => u.is_default) ?? universes[0];
			id_universe = defaultUniverse?.id_universe;
		}
		if (!id_universe) return;

		const universe = universes.find(u => u.id_universe == id_universe);
		if (!universe) return;

		// Guardar en backend
		try {
			const url = this.sharedService.urls.users.universe;
			const res: any = await firstValueFrom(
				this.http.post(url, { id_universe })
			);

			if (res?.error) throw new Error(res.error);
		} catch (error) {
			console.error('selectUniverse error', error);
		}
		
		// Esto dispara automáticamente a todos los suscritos
		this.currentUniverseSubject.next(universe);

	}


}